import React, { useCallback } from 'react';

const WidgetAPIError = (props) => {
  const { error } = props;

  const errorRef = useCallback((node) => {
    if (node !== null) {
      node.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  if (!error) {
    return null;
  }

  return (
    <div
      className="c7-message c7-message--alert-error"
      role="alert"
      ref={errorRef}
    >
      <svg
        aria-hidden="true"
        focusable="false"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      {error}
    </div>
  );
};

export default WidgetAPIError;
